import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';
import { CanvasState } from '../../slices/canvas';

export const selectIsLooping = (): any =>
    createSelector(
        (state: RootState) => state.canvas,
        (canvas: CanvasState) => canvas.isLooping,
    );
